import { render, staticRenderFns } from "./Return-old.vue?vue&type=template&id=cf4fb4ee&"
import script from "./Return-old.vue?vue&type=script&lang=js&"
export * from "./Return-old.vue?vue&type=script&lang=js&"
import style0 from "./Return-old.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports